import{styled as t}from"@mui/material/styles";import e from"@mui/material/Box";var i=t(e,{label:"Icon"})((function(t){return{display:"flex",justifyContent:"center",alignItems:"center",width:40,height:40}}));export{i as default};
//# sourceMappingURL=Icon.js.map
